import { render, staticRenderFns } from "./VTRomInfo.vue?vue&type=template&id=1768627d&scoped=true&"
import script from "./VTRomInfo.vue?vue&type=script&lang=js&"
export * from "./VTRomInfo.vue?vue&type=script&lang=js&"
import style0 from "./VTRomInfo.vue?vue&type=style&index=0&id=1768627d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1768627d",
  null
  
)

export default component.exports